export default __webpack_public_path__ + "locales/el-GR/PaymentsEnterprise.json?hash=62e0316d43094346a5e55af6aeb8a2ce";